// extracted by mini-css-extract-plugin
export default {"info":"_5782j","time":"_9uaC2","title":"Jsw6A","ellipsis":"QYrc8","more":"XYWgc"};